
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["loadModel","disposeModel","predict"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "d8fa3d4ad6d66317851b.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			